import { ActionTypes as ContentActionTypes } from '../reducers/Content'

export const fetchFeatured = () => async (dispatch, getState, api) => {
  if (getState().Content.featured.length) return

  const response = await api.fetchFeatured()

  dispatch({
    type: ContentActionTypes.SET_FEATURED,
    featured: response
  })
}

export const searchTerm = term => async (dispatch, getState, api) => api.searchTerm(term)

export const fetchPage = page => async (dispatch, getState, api) => {
  const request = api.fetchPage(page)

  request.then(res => {
    if (res) {
      dispatch({
        type: ContentActionTypes.SET_PAGE_CONTENT,
        page,
        contents: res
      })
    }
  })

  return request
}

export const addBookmark = item => async (dispatch, getState, api) => api.addBookmark(item)
export const removeBookmark = item => async (dispatch, getState, api) => api.removeBookmark(item)



// WEBPACK FOOTER //
// ./src/store/actions/Content.js